import type { RootState } from '../store'
import type { Organization } from './types'

type OrganizationBooleanFeature = {
  [Key in keyof Organization]-?: NonNullable<Organization[Key]> extends boolean
    ? Key
    : never
}[keyof Organization]

export const selectHasApprovalFeature = (
  state: RootState,
): boolean | undefined => state?.organizations?.selected?.hasApprovalFeature

export const selectHasFirstCommentEntitlement = (
  state: RootState,
): boolean | undefined => state?.organizations?.selected?.hasFirstCommentFeature

export const selectHasFirstCommentForLinkedinEntitlement = (
  state: RootState,
): boolean =>
  !!state?.organizations?.selected?.hasFirstCommentFeatureForLinkedin

export const selectCurrentOrganizationId = (state: RootState): string =>
  state?.organizations?.selected?.id ?? ''

export const selectHasFeature = (
  state: RootState,
  feature: OrganizationBooleanFeature,
): boolean => state?.organizations?.selected?.[feature] || false

export const selectHasContentFeature = (
  state: RootState,
): boolean | undefined => state?.organizations?.selected?.hasContentFeature

export const selectShouldShowNBMigration = (
  state: RootState,
): boolean | undefined =>
  state?.organizations?.selected?.shouldShowNBMigrationModal
